import { useState } from 'react'
import { useLineNotify } from '../hooks/useLineNotify'

const TO_STORAGE_KEY = 'noah_line_to'

/**
 * LINE通知コンポーネント
 *
 * 送信先チャットID（group/room/user）と本文を入力し、LINE へテキストを送信する
 * シンプルな送信フォーム。チャットIDは localStorage に保存して次回も再表示する。
 */
export function LineNotify() {
  const { sending, error, sendMessage, clearError } = useLineNotify()
  const [to, setTo] = useState(() => localStorage.getItem(TO_STORAGE_KEY) ?? '')
  const [text, setText] = useState('')
  const [successMessage, setSuccessMessage] = useState<string | null>(null)

  const handleToChange = (value: string) => {
    setTo(value)
    localStorage.setItem(TO_STORAGE_KEY, value)
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSuccessMessage(null)
    clearError()

    const trimmedTo = to.trim()
    const trimmedText = text.trim()
    if (!trimmedTo || !trimmedText) return

    const ok = await sendMessage(trimmedTo, trimmedText)
    if (ok) {
      setText('')
      setSuccessMessage('LINE へ送信しました')
    }
  }

  return (
    <div className="settings">
      <h2>LINE通知</h2>

      <div className="settings-section">
        <h3>メッセージを送信</h3>
        <p className="settings-description">
          送信先のチャットID（グループ／ルーム／ユーザー）と本文を入力して送信します。
          チャットIDは LINE で bot に話しかけると、Webコールバックが返信します。
          一度入力したチャットIDはこの端末に保存され、次回も表示されます。
        </p>

        {error && <div className="settings-error">{error}</div>}
        {successMessage && <div className="settings-success">{successMessage}</div>}

        <form className="settings-form" onSubmit={handleSubmit}>
          <div className="settings-field">
            <label htmlFor="line-to">チャットID</label>
            <input
              id="line-to"
              type="text"
              className="settings-input"
              value={to}
              onChange={(e) => handleToChange(e.target.value)}
              placeholder="例: Uxxxxxxxx / Cxxxxxxxx"
              disabled={sending}
            />
          </div>

          <div className="settings-field">
            <label htmlFor="line-text">本文</label>
            <textarea
              id="line-text"
              className="settings-input line-notify-textarea"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="送信するメッセージを入力"
              rows={4}
              disabled={sending}
            />
          </div>

          <div className="settings-actions">
            <button
              type="submit"
              className="button button-primary"
              disabled={sending || !to.trim() || !text.trim()}
            >
              {sending ? '送信中...' : '送信'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
